const WizardProgress = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
      <nav aria-label="Progress">
        <ol className="flex items-center justify-between">
          {steps.map((step, index) => {
            const isCompleted = step.id < currentStep;
            const isCurrent = step.id === currentStep;
            const isClickable = step.id <= currentStep;

            return (
              <li key={step.id} className="relative flex-1">
                {index !== 0 && (
                  <div
                    className={`absolute left-0 top-4 -translate-y-1/2 w-full h-0.5 -ml-2 lg:-ml-4
                      ${isCompleted ? "bg-teal-600" : "bg-gray-200"}`}
                    style={{ width: "calc(100% - 1rem)" }}
                  />
                )}

                <button
                  type="button"
                  onClick={() => isClickable && onStepClick(step.id)}
                  disabled={!isClickable}
                  className={`relative flex flex-col items-center group ${
                    isClickable ? "cursor-pointer" : "cursor-not-allowed"
                  }`}
                >
                  <span
                    className={`flex items-center justify-center w-8 h-8 rounded-full border-2 text-sm font-medium transition-all
                      ${isCompleted
                        ? "bg-teal-600 border-teal-600 text-white"
                        : isCurrent
                        ? "bg-white border-teal-600 text-teal-600"
                        : "bg-white border-gray-300 text-gray-400"
                      }
                      ${isClickable && !isCurrent ? "group-hover:border-teal-400" : ""}
                    `}
                  >
                    {isCompleted ? (
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : (
                      step.id
                    )}
                  </span>

                  <div className="mt-2 text-center hidden sm:block">
                    <span
                      className={`text-xs font-medium block ${
                        isCurrent ? "text-teal-600" : isCompleted ? "text-gray-700" : "text-gray-400"
                      }`}
                    >
                      {step.title}
                    </span>
                    <span className="text-xs text-gray-400 hidden lg:block">
                      {step.description}
                    </span>
                  </div>
                </button>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default WizardProgress;
